import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useContext, type FC } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";

import { BulkPreviewStepConflictsContext } from "../bulk-preview-step-conflicts.context";
import { RejectedBookingExpanded } from "./rejected-bookings-expanded";
import { RejectedBookingsStatusMismatchRow } from "./rejected-bookings-status-mismatch-row";

/** Bookings skipped because their status may not be edited - reported only, never approvable. */
export const RejectedBookingsStatusMismatchTable: FC = () => {
  const { conflicts } = useContext(BulkPreviewStepConflictsContext);
  const { t } = useTranslation();

  return (
    <RejectedBookingExpanded>
      <ExpandedTable dataE2E="rejected-bookings-status-mismatch">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("booking.bulk.bookingId")}</TableCell>
              <TableCell>{t("booking.bulk.passengerFullName")}</TableCell>
              <TableCell>{t("booking.bulk.date")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map(conflictRow => (
              <RejectedBookingsStatusMismatchRow
                key={`${conflictRow.bookingId}_${conflictRow.id}`}
                conflictRow={conflictRow}
              />
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RejectedBookingExpanded>
  );
};
